// extracted by mini-css-extract-plugin
export default {"header":"header__3ax1h","logo_container":"logo_container__Ww4S7","back_container":"back_container__1sBpE logo_container__Ww4S7","active":"active__2XB2z","logo":"logo__3Ki4n"};